import { Controller } from "@hotwired/stimulus";
import { whenConsentGranted } from "../lib/cookiebot_consent";

const POLL_MS = 100;
const GIVE_UP_MS = 10000;

/**
 * Reports which "Is Recommended For..." cards rendered, so the experiment can
 * be read by trait and not only by arm. Fires once per page load.
 */
export default class extends Controller {
	static values = {
		keys: Array,
		recipe: String,
	};

	connect() {
		this.consentSubscription = whenConsentGranted("statistics", () =>
			this.capture(),
		);
	}

	disconnect() {
		this.consentSubscription?.();
		this.consentSubscription = null;
		window.clearTimeout(this.retryId);
		this.retryId = null;
	}

	/**
	 * posthog_setup injects the stub on DOMContentLoaded, after this connects,
	 * so window.posthog can still be missing once consent fires. Poll briefly
	 * rather than drop the event.
	 *
	 * @param {number} waited - milliseconds spent waiting so far
	 */
	capture(waited = 0) {
		if (typeof window.posthog?.capture === "function") {
			window.posthog.capture("prp_recipe_cards_shown", {
				card_keys: this.keysValue,
				recipe: this.recipeValue,
			});
			return;
		}

		if (waited >= GIVE_UP_MS) return;

		this.retryId = window.setTimeout(
			() => this.capture(waited + POLL_MS),
			POLL_MS,
		);
	}
}
